<template>
    <div>
        <div elevation="0" color="transparent" flat>
            <div class="row mb-8">
                <div class="col-6 d-flex justify-content-start">
                    <v-card-title>
                        {{ $t('priceLists.priceLists') }} {{productName ? "( " + productName + " )" : ''}}
                    </v-card-title>
                </div>
                <div class="col-6 d-flex justify-content-end">
                    <genericBtnComponent @click="AddProductsPrice = true" svg="1" :Title="$t('priceLists.add')" />
                </div>
            </div>
        </div>
        <v-card elevation="0" flat>
            <v-tabs v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
                <!-- <v-tab class="slider" value="option-1" :style="tab =='option-1' ? Active : NotActive" centered>
                    {{ $t('priceLists.priceList') }}
                </v-tab> -->
                <v-tab class="slider" value="option-2" :style="tab =='option-2' ? Active : NotActive">
                    {{ $t('priceLists.priceOffer') }}
                </v-tab>
            </v-tabs>
            <v-divider class="ma-0"></v-divider>
            <v-window v-model="tab" :key="tab">
                <v-window-item value="option-1">
                    <ProductPriceList ref="ProductsPriceListRef1" :DiscountType="[0]" :ProductVariants="ProductVariants" />
                </v-window-item>
                <v-window-item value="option-2">
                    <ProductPriceList ref="ProductsPriceListRef2" :DiscountType="[1,2]" :ProductVariants="ProductVariants" />
                </v-window-item>
            </v-window>
        </v-card>
    </div>

    <AddProductsPrice v-model="AddProductsPrice" @add-ProductsPrice-close-dialog="AddProductsPrice = false"
        @reloadListProductsPrice="ReloadListProductsPrice" ref="AddProductsPricesRef" :ProductVariants="ProductVariants"/>
</template>
<script>
import { getProductById } from "@/api";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import AddProductsPrice from "./AddProductsPrice.vue";
import ProductPriceList from "./ProductPriceList.vue";

export default {
    components: {
        ProductPriceList,
        genericBtnComponent,
        AddProductsPrice
    },
    data: () => ({
        AddProductsPrice: false,
        productName: '',
        ProductVariants: null,
        tab: "option-1",
        NotActive: {
            color: "#667280",
            fontSize: "14px",
            font: "inter",
        },
        Active: {
            color: "blue",
            fontSize: "14px",
            font: "inter",
        },
    }),
    async mounted() {
        await this.GetProductById(this.$route.params.id);
    },
    methods: {
        async GetProductById(productId) {
            await getProductById(productId).then(({ data }) => {
                this.productName = data.name;
                this.ProductVariants = data.variants
            });
        },
        navigateToNewProduct() {
            this.$router.push({ name: 'NewProduct' });
        },
        ReloadListProductsPrice() {
            this.$refs.ProductsPriceListRef1.getPriceListProduct()
            this.$refs.ProductsPriceListRef2.getPriceListProduct()
        },
    },
};
</script>
<style scoped>
.v-card-title {
    font-size: 14px;
    font-family: inter;
    font-weight: 600;
}

.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}
</style>